import { RouteComponentProps } from "@reach/router"
import toggles from 'feature-toggles'
import React from "react"

import Subnav from "components/subnav"
import { Container_s, Content_s } from "styles/app-styles"

type Route = {
  name: string
  link: string
}
type FolderState = {
  tabs: Route[]
}
class Folder extends React.Component<RouteComponentProps, FolderState> {
  constructor(props) {
    super(props)
    this.state = {
      tabs: []
    }
  }
  componentWillMount() {
    toggles.get().then(() => {
      const folderExplorer = toggles.displayFolderExplorer() ? [{name: "Folder Explorer", link: "/n/folder/explorer"}] : [{name: "Folder Explorer", link: "/folder/explorer", hard: true}]
      const folderSettings = toggles.permissions() ? [{name: "Folder Settings", link: "/n/folder/settings"}] : [{name: "Folder Settings", link: "/folder/settings", hard: true}]
      const folderReportTag = toggles.displayFolderReports() ? [{name: "Reports", link: "/n/folder/reports"}] : []
      const auditLogTab = toggles.displayFolderAuditLog() ? [{name: "Audit Log", link: "/n/folder/audit-log"}] : [{name: "Audit Log", link: "/folder/audit-log", hard: true}]
      const importExport = toggles.displayVTSImport() ? [{name: "Import/Export", link: "/folder/import-export"}] : [{name: "Import/Export", link: "/n/folder/import-export"}]

      const tabs = [
        ...folderExplorer,
        ...folderSettings,
        {name: "Underwriting Workbook", link: "/n/folder/underwriting-workbook"},
        ...folderReportTag,
        {name: "Snapshots", link: "/n/folder/snapshots"},
        {name: "Property List", link: "/n/folder/property-list"},
        ...importExport,
        ...auditLogTab
      ]
      this.setState({tabs})
    })
  }
  render() {
    return (
      <Container_s>
        {this.state.tabs.length > 0 && <Subnav section="FOLDER" tabs={this.state.tabs}/>}
        <Content_s>
          {this.props.children}
        </Content_s>
      </Container_s>
    )
  }
}

export default Folder
